import React, { useContext } from 'react';
import { UserContext } from '@secretescapes/cauldron';
import { Button } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useApplicationState } from '@utils/useApplicationState';
import { usePageLoad } from '@utils/usePageLoad';
import { useTranslations } from '@utils/useTranslations';
import { handleLoginClick, redirectToLogin } from '../../SalePageMobile.utils';

export interface NavigationCtaButtonProps {
  onCtaClick: () => void;
  showPricingAndAvailability: boolean;
  showFinalRates: boolean;
}

export const NavigationCtaButton = ({
  onCtaClick,
  showPricingAndAvailability,
  showFinalRates,
}: NavigationCtaButtonProps) => {
  const { userId } = useContext(UserContext);
  const { isMobile } = useApplicationState();
  const { translations } = useTranslations();

  const buttonLabel = i18n(
    showFinalRates ? 'sale.view.offers.cta' : 'common.date.checkAvailability',
    [],
    translations
  );

  const triggerIAModalActionLabel = i18n('joinNow.text', [], translations);

  const pageLoaded = usePageLoad();

  const handleIAClick = () => {
    if (isMobile) {
      redirectToLogin();
    } else {
      handleLoginClick(false);
    }
  };

  if (showPricingAndAvailability) {
    return (
      <Button onClick={onCtaClick} disabled={!pageLoaded}>
        {buttonLabel}
      </Button>
    );
  }

  if (!userId) {
    return (
      <Button onClick={handleIAClick} fullWidth={isMobile}>
        {triggerIAModalActionLabel}
      </Button>
    );
  }

  return null;
};
